import React from 'react'
import { RouteComponentProps } from 'react-router'
import { IPageRenderConfig, IAutoRefresh, IDateRange, IKeyValue } from '@fareye/types'
import { setDateFromStorage } from '@fareye/common'
import { getQueryParams } from '@fareye/utils'
import { styled } from '@fareye/ui'
import queryString, { ParsedQuery } from 'query-string'
import HeaderFilter from '../components/headerFilter/HeaderFilter'
import SummaryList from '../components/summary/SummaryList'
import MultiModalTripListing from '../components/multiModalTripListing/MultiModalTripListing'
import { ISelecetedFilters, ISummaryData } from '../utility/types'



interface IMultiModalOpsDashboard extends RouteComponentProps, IAutoRefresh {
  config: IPageRenderConfig
}

const MultiModalOpsDashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 15px;
  gap: 15px;
  overflow: hidden;
  box-shadow: inset 0px 5px 10px -5px rgba(239,239,239,1);
  background: #F4F5F7;
  overflow-y: scroll;
`

const HeaderContainer = styled.div` Flex: 0 0 auto; `
const SummaryContainer = styled.div` Flex: 0 1 auto; `
const ListingContainer = styled.div` Flex: 1 0 auto; `

export const MultiModalOpsDashboard: React.FC<IMultiModalOpsDashboard> =  ({
  match,
  config,
  history,
  location,
  maxRefreshCount,
  refreshInterval
}) => {
  const { children, styling, globalSearchPageId, filters } = config
  // TODO: Use styling in layout
  const { style, className, bodyBgColor, variant, layoutStyle } = styling

  const {
    carryDate = true,
    pageType = { label: 'Shipments', value: 'journey', dataSource: 'Journey' },
    additionalDays = 0,
    initialSelectedFilters = {}
  } = config.config as any

  const [summaryData, setSummaryData] = React.useState<ISummaryData>({})

  const searchParams: ParsedQuery<string | Date> = queryString.parse(
    location.search
  )

  const [selectedFilters, setSelectedFilters] = React.useState<ISelecetedFilters>({
    dateRange: {
      // TODO: use start_date from config
      start_date: setDateFromStorage({
        showDatePicker: true,
        carryDate,
        searchParams,
        daysDiff: 20
      }) as IDateRange<Date>
    },
    ...initialSelectedFilters
  })

  const upsertSelectedFilters = (filterType: string, filterKey: string, filterValue: any) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [filterType]: {
        ...(prevFilters[filterType] || {}),
        [filterKey]: filterValue,
      }
    }))
  }

  React.useEffect(() => {
    // update queryParams
    // TODO: use start_date from config
    const { startDate, endDate } = selectedFilters.dateRange['start_date']
    let prevStartDate = searchParams.startDate
    let prevEndDate = searchParams.endDate
    if (prevStartDate !== startDate || prevEndDate !== endDate) {
      const queryParams = getQueryParams({
        ...queryString.parse(location.search),
        startDate,
        endDate
      })
      history.replace({
        pathname: match.url,
        search: queryParams
      })
    }

    // update Storage
    localStorage.setItem('date', JSON.stringify(selectedFilters.dateRange['start_date']))
  }, [selectedFilters.dateRange])

  let maxDate = new Date()
  maxDate.setDate(maxDate.getDate() + additionalDays)

  const { 
    headerFilter: headerFilterConfig,
    summaryList: summaryListConfig,
    multiModalTripListing: multiModalTripListingConfig
  } = children as IKeyValue<IPageRenderConfig>

  return (
    <MultiModalOpsDashboardContainer>
      <HeaderContainer>
        <HeaderFilter
          summaryData = {summaryData}
          selectedFilters = {selectedFilters}
          config = {headerFilterConfig}
          upsertSelectedFilters = {upsertSelectedFilters}
          additionalDays = {additionalDays}
        />
      </HeaderContainer>
      <SummaryContainer>
        <SummaryList
          summaryData = {summaryData}
          selectedFilters = {selectedFilters}
          config = {summaryListConfig}
          upsertSelectedFilters = {upsertSelectedFilters}
        />
      </SummaryContainer>
      <ListingContainer>
        <MultiModalTripListing
          config = {multiModalTripListingConfig}
          pageType = {pageType}
          history={history}
          location={location}
          match={match}
          refreshInterval = {refreshInterval}
          maxRefreshCount = {maxRefreshCount}
          setSummaryData = {setSummaryData}
          selectedFilters = {selectedFilters}
        />
      </ListingContainer>
    </MultiModalOpsDashboardContainer>
  )
}